import React from "react";
import "./../../About/OurStory/OurStory.css";
//import "./Disclaimer.css";
import { Container, Col, Row } from "react-bootstrap";
function PrivacyPolicy() {
  return (
    <>
      <section className="our-story-block disclaimer">
        <Container>
          <Row>
            <Col md={{ span: 12, offset: 0 }}>
              <div className="our-story-inner arrow-main">
                <h2>Privacy Policy</h2>
                <p>
                  We at Moneysukh recognize the importance of protecting your
                  personal and financial information. We assure that the
                  information parted to us will kept in strict confidentiality
                  and to use the information only for to help us service your
                  account, to improve our services to you, to provide you with
                  products you have requested, and to inform you about
                  additional products or services that may be of interest to
                  you. We do not sell your personal information to third
                  parties.
                </p>
                <p>
                  The Moneysukh site contains links to and from other Web sites.
                  Moneysukh is not responsible for the privacy practices or the
                  content of such Web sites.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default PrivacyPolicy;
